import {createAction, createReducer} from '@reduxjs/toolkit';

const initialState = false;

export const setWarningVisibility = createAction<boolean>('CHECKOUT@SET_AUTHORIZE_WARNING');

/**
 * Authorize Warning state
 * @return {boolean} State
 */
export const authorizeWarning = createReducer<boolean>(initialState, builder =>
    builder.addCase(setWarningVisibility, (state, action) => action.payload),
);
